import { useContext, useState } from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';

import Button from '../../../../reusable/button/button.component';

import Client from '../../../../../tools/client';
import { ToastContext } from '../../../../../contexts/toast.context';

import {
  MainContainer
} from '../../../../../styles/component.styles';

const client = new Client();

const HcaptchaIntegrationPanel = ({ integration }) => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const { successToast, errorToast } = useContext(ToastContext);

  const siteKey = integration?.secrets?.find(s => s.keyName === 'siteKey')?.encryptedValue;

  const handleVerify = async () => {
    if (!captchaToken) {
      errorToast('Please complete the CAPTCHA before testing.');
      return;
    }

    setLoading(true);
    try {
      // ✅ Remove siteKey from the request body
      const res = await client.testIntegrationById(integration.id, { token: captchaToken });

      if (res.success) {
        successToast('hCaptcha key is valid.');
      } else {
        errorToast(`Validation failed: ${res.message || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('hCaptcha test error:', err);
      errorToast('Error validating hCaptcha. Check console for details.');
    } finally {
      setLoading(false);
    }
  };

  if (!siteKey) {
    return (
      <MainContainer>
        <p style={{ marginTop: '1rem', color: 'red' }}>Missing siteKey for this integration.</p>
      </MainContainer>
    );
  }

  return (
    <MainContainer>
      <HCaptcha
        sitekey={siteKey}
        onVerify={setCaptchaToken}
        size="compact"
      />

      <Button
        style={{ marginTop: '1rem' }}
        onClick={handleVerify}
        disabled={!captchaToken || loading}
      >
        {loading ? 'Testing...' : 'Test hCaptcha'}
      </Button>
    </MainContainer>
  );
};

export default HcaptchaIntegrationPanel;